import { useState } from "react";
import { useAuth } from "@/lib/auth";
import AdvancedCandidateFilters from "@/components/AdvancedCandidateFilters";
import CandidateList from "@/components/CandidateList";
import CandidateCreateModal from "@/components/CandidateCreateModal";
import CandidateAssignModal from "@/components/CandidateAssignModal";
import { useEmployees } from "@/hooks/useEmployees";
import { Plus } from "@phosphor-icons/react";

export default function Candidates() {
  const { user } = useAuth();
  const employees = useEmployees();
  const [items, setItems] = useState([]);
  const [createOpen, setCreateOpen] = useState(false);
  const [assignId, setAssignId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const canWrite = user?.role !== "executive" && user?.role !== "sde";

  return (
    <div className="space-y-5" data-testid="candidates-page">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-semibold">Candidates</h2>
          <p className="text-sm text-slate-500">Track service delivery for every enrolled candidate.</p>
        </div>
        {canWrite && (
          <button
            onClick={() => setCreateOpen(true)}
            data-testid="add-candidate-button"
            className="bg-sky-600 hover:bg-sky-700 text-white text-sm px-4 py-2 rounded-md flex items-center gap-2 transition-colors"
          >
            <Plus size={16} /> Add Candidate
          </button>
        )}
      </div>

      <AdvancedCandidateFilters key={refreshKey} employees={employees} onResults={setItems} />

      <CandidateList items={items} employees={employees} canWrite={canWrite} onAssign={setAssignId} />

      {createOpen && (
        <CandidateCreateModal onClose={() => setCreateOpen(false)} onCreated={() => setRefreshKey((k) => k + 1)} />
      )}

      {assignId && (
        <CandidateAssignModal
          candidateId={assignId}
          employees={employees}
          onClose={() => setAssignId(null)}
          onAssigned={() => setRefreshKey((k) => k + 1)}
        />
      )}
    </div>
  );
}
